import React from "react";
import StatsColumn from "../StatsColumn";
import InfoColumns from "./InfoColumns";
import VariableChart from "../VariableChart";
import { browserHistory } from "react-router";
import PieChart from "../PieChart";
import { StatsData } from "./models/stats";
import { chartDefaultColors } from "../../chartDefaultColors";
import { calculateTotalColumn } from "../../utils";
import { Link } from "react-router";
import { ApolloConsumer } from "@apollo/client";
import {
  GET_STATS_BY_BUYER_STATE,
  GET_STATS_BY_STATUS,
  GET_STATS_BY_TYPE,
  CLOSING_STATS
} from "../Graphql/Queries/HscStatsQuery";
import { mapToOldResponse } from "../ResponseConversion/GetOldResponse";
import { fetchData } from "../Service/graphQlService";
import { striveLogo } from "../../consts/consts";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

const cloneDeep = require("lodash.clonedeep");
const variableChartData = [
  {
    name: "STNL",
    y: 0,
    z: 1,
    color: "#A7A9AC",
  },
  {
    name: "MT",
    y: 0,
    z: 5,
    color: "#A0D967",
  },
  {
    name: "MF",
    y: 0,
    z: 7,
    color: "#FF0000",
  },
  {
    name: "Other",
    y: 0,
    z: 7,
    color: "black",
  },
];

export default class Stats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: new StatsData({}),
      totalClosedSum: null,
      totalClosedCount: null,
      listedChartData: cloneDeep(variableChartData),
      soldChartData: cloneDeep(variableChartData),
      buyerStateYtdChartData: [],
      buyerStateChartData: [],
      buyerStateYtdTotal: 0,
      buyerStateTotal: 0,
      isYtdClosing: true,

    };

    this.handleChange = this.handleChange.bind(this);
  }

  static buildBuyerStateChartData(data) {
    const chartOptionsData = [];
    let index = 0,
      otherPercentage = 0,
      otherCount = 0,
      total = 0;

    if (data && data.length) {
      const totalProperties = calculateTotalColumn(data, "TOTAL_PROPERTIES");

      data.forEach((row, rowIndex) => {
        if (rowIndex < 3) {
          total += parseInt(row.TOTAL_PROPERTIES);
          chartOptionsData.push({
            name: row.COMPANY_STATE,
            y: parseInt(row.TOTAL_PROPERTIES),
            color: chartDefaultColors[index++],
          });
        } else {
          total += parseInt(row.TOTAL_PROPERTIES);
          const percentage = (row.TOTAL_PROPERTIES / totalProperties) * 100;
          row.PERCENTAGE = percentage ? percentage.toFixed(2) : 0;
          otherPercentage += parseFloat(row.PERCENTAGE);
          otherCount += parseInt(row.TOTAL_PROPERTIES);
        }
      });

      if (otherPercentage && otherCount) {
        chartOptionsData.push({
          name: "Other",
          y: otherCount,
          color: chartDefaultColors[index],
        });
      }
    }

    return { chartOptionsData, total };
  }

  handleChange(e) {
    this.setState({ source: e.currentTarget.value });
  }

  static buildChartOptions(currentAgentData) {
    if (currentAgentData) {
        const options = {
            chart: {
                type: "column",
                width: 800,
            },
            title: {
                text: "<b>STRIVE Closings</b>",
                useHTML: true
            },
            xAxis: {
                categories: currentAgentData.map(data => data.CLOSE_OF_ESCROW),
            },
            yAxis: {
                title: {
                    text: ""
                },
                tickPositions: [0, 100000000, 200000000, 300000000, 400000000, 500000000, 600000000, 700000000, 800000000, 900000000, 1000000000],
                labels: {
                    formatter: function () {
                        const value = this.value / 1000000; 
                        return `$${value}M`; 
                    }
                }
            },
            tooltip: { enabled: false },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    events: {
                        click: function (event) {
                            window.open(`/list?source=STRIVE&status=Closed&close_of_escrow_min=01%2F01%2F${event.point.category}&close_of_escrow_max=12%2F31%2F${event.point.category}&order=close_of_escrow.desc`, 'blank');
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        align: 'center',
                        crop: false,
                        overflow: 'none',
                        allowOverlap: true,
                        padding: 0,
                        style: { textOutline: 'none' },
                        useHTML: true,
                        formatter: function () {

                            return `<div style="position: relative;">$${Highcharts.numberFormat(this.y, 0)}<span style="position: absolute; top: 25px; left: 28px; color: white">${this.point.closed}</span></div>`
                        }
                    }
                }
            },
            series: [{
                name: 'Closed Properties',
                color: 'rgb(160, 217, 103)',
                data: currentAgentData.map(data => {
                    const price = Number(data[`CLOSED_PRICE`]);
                    const closed = Number(data['CLOSED_PROPERTIES']);
                    return {
                        name: data.CLOSE_OF_ESCROW,
                        y: Number.isFinite(price) ? price : 0,
                        closed: Number.isFinite(closed) ? closed : 0
                    };
                })
            }]
        }
        return options;
    }

    return null;
}

  fetch() {
    const ytd = new Date().getFullYear();
    const sinceDate = `${ytd - 2}-01-01`; // since 2 years ago

    if (this.client) {
      Promise.all([
        // this.client.query({
        //     query: GET_STATS_BY_STATUS, variables:  {since: sinceDate},  fetchPolicy: "no-cache",

        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // }),
        fetchData(GET_STATS_BY_STATUS, { since: sinceDate }),
        // this.client.query({
        //     query: GET_STATS_BY_TYPE, fetchPolicy: "no-cache",

        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // }),
        fetchData(GET_STATS_BY_TYPE),
        // this.client.query({
        //     query: GET_STATS_BY_BUYER_STATE, variables:  {date: `${ytd}`}, fetchPolicy: "no-cache",

        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // }),
        fetchData(GET_STATS_BY_BUYER_STATE, { date: `${ytd}` }),
        // this.client.query({
        //     query: GET_STATS_BY_BUYER_STATE, variables:  {date: `${ytd - 1}` }, fetchPolicy: "no-cache",

        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // }),
        fetchData(GET_STATS_BY_BUYER_STATE, { date: `${ytd - 1}` }),
        fetchData(GET_STATS_BY_BUYER_STATE, { date: `${ytd - 2}` }),
        fetchData(CLOSING_STATS)
      ]).then((res) => {
        const result = mapToOldResponse(res).responses;
      

        if (
          result &&
          result[0] &&
          result[0].data[0].STATSBYSTATUS.SUCCESS &&
          Array.isArray(result[0].data[0].STATSBYSTATUS.DATA) &&
          result[1] &&
          result[1].data[0].STATSBYTYPE.SUCCESS &&
          Array.isArray(result[1].data[0].STATSBYTYPE.DATA) &&
          result[2] &&
          result[2].success &&
          Array.isArray(result[2].data[0].GETSTATSBYBUYERSTATE) &&
          result[3] &&
          result[3].success &&
          Array.isArray(result[3].data[0].GETSTATSBYBUYERSTATE) &&
          result[4] &&
          result[4].success &&
          Array.isArray(result[4].data[0].GETSTATSBYBUYERSTATE) &&
          result[5] &&
          result[5].success &&
          Array.isArray(result[5].data[0].CLOSINGSTATS.DATA)
        ) {
         
          const stats = new StatsData({
            dataByStatus: result[0].data[0].STATSBYSTATUS.DATA[0],
            dataByType: result[1].data[0].STATSBYTYPE.DATA[0],
          });

          const isYtdClosing = !(
            result[0].data[0].STATSBYSTATUS.DATA[0] &&
            result[0].data[0].STATSBYSTATUS.DATA[0].CLOSED_YTD_PROPERTIES &&
            parseInt(
              result[0].data[0].STATSBYSTATUS.DATA[0].CLOSED_YTD_PROPERTIES
            ) < 7
          );

          const { listedChartData, soldChartData } = cloneDeep(this.state);
          listedChartData[0].y = stats.activeStnlCount;
          listedChartData[1].y = stats.activeMtCount;
          listedChartData[2].y = stats.activeMfCount;
          listedChartData[3].y = stats.activeOtherCount;
          soldChartData[0].y = stats.closedStnlCount;
          soldChartData[1].y = stats.closedMtCount;
          soldChartData[2].y = stats.closedMfCount;
          soldChartData[3].y = stats.closedOtherCount;

          // let sum = res[1].data[0].CLOSED_PRICE;
          // let count = res[1].data[0].CLOSED_COUNT;
          let sum = result[1].data[0].STATSBYTYPE.DATA[0].CLOSED_PRICE;
          let count = result[1].data[0].STATSBYTYPE.DATA[0].CLOSED_COUNT;
          sum = (sum / Math.pow(10, 9)).toString();
          sum = sum.slice(0, sum.indexOf(".") + 2);
          count = parseInt(count / 25) * 25;

          //let chartData = Stats.buildBuyerStateChartData(isYtdClosing ? res[2].data : res[3].data);
          let chartData = Stats.buildBuyerStateChartData(
            isYtdClosing
              ? result[2].data[0].GETSTATSBYBUYERSTATE
              : result[3].data[0].GETSTATSBYBUYERSTATE
          );
          const buyerStateYtdChartData = chartData.chartOptionsData;
          const buyerStateYtdTotal = chartData.total;
          //chartData = Stats.buildBuyerStateChartData(res[4].data);
          chartData = Stats.buildBuyerStateChartData(
            result[4].data[0].GETSTATSBYBUYERSTATE
          );
          const buyerStateChartData = chartData.chartOptionsData;
          const buyerStateTotal = chartData.total;

          const toNumber = value => {
            const num = Number(value);
            return Number.isFinite(num) ? num : 0;
          };
          const convertedBarData = result[5].data[0].CLOSINGSTATS.DATA.filter(data => Number(data.CLOSE_OF_ESCROW) >= 2017).reduce((acc, curr) => {
            const found = acc.find(item => item.CLOSE_OF_ESCROW == curr.CLOSE_OF_ESCROW);
            if (found) {
                found.CLOSED_PRICE = found.CLOSED_PRICE + toNumber(curr.CLOSED_PRICE);
                found.CLOSED_PROPERTIES = found.CLOSED_PROPERTIES + toNumber(curr.CLOSED_PROPERTIES);
            } else {
                acc.push({
                    CLOSED_PRICE: toNumber(curr.CLOSED_PRICE), CLOSED_PROPERTIES: toNumber(curr.CLOSED_PROPERTIES)
                    , CLOSE_OF_ESCROW: curr.CLOSE_OF_ESCROW
                })
            }
            return acc;
        }, [])
        if(Object.keys(convertedBarData).length){
            convertedBarData.sort((a, b) => a.CLOSE_OF_ESCROW - b.CLOSE_OF_ESCROW);
        }
        let barChartData = Stats.buildChartOptions(convertedBarData)
        
          this.setState({
            stats,
            listedChartData,
            soldChartData,
            totalClosedSum: sum,
            totalClosedCount: count,
            buyerStateYtdChartData,
            buyerStateChartData,
            buyerStateYtdTotal,
            buyerStateTotal,
            isYtdClosing,
            barChartData
          });
        }
      });
    }
  }
  componentDidMount() {
    //here if condition added
    if (this.client) {
      this.fetch();
    }
  }

  render() {
    let {
      stats,
      listedChartData,
      soldChartData,
      buyerStateYtdChartData,
      buyerStateChartData,
      buyerStateYtdTotal,
      buyerStateTotal,
      totalClosedCount,
      totalClosedSum,
      isYtdClosing,
    } = this.state;
    const ytd = new Date().getFullYear();

    soldChartData = soldChartData.map((e) => {
      e.total = stats.closedCount;
      return e;
    });
    listedChartData = listedChartData.map((e) => {
      e.total = stats.activeCount;
      return e;
    });
    const d = new Date();
    const date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) {
            this.client = client;
            //this.fetch(this.props.location.query);
          }
          return (
            <React.Fragment>
              <div className="Stats">
                <div className="page-rounded-corner-container">
                  <div className="page-header-container">
                    <div className="page-header">
                      <div className="page-title">Stats</div>
                    </div>
                    <div className="line" />
                  </div>
                </div>
                <div className="Stats_header">
                  <h3 className="Stats_h3">Stats</h3>
                  <h4 className="Stats_h4">{date}</h4>
                </div>
                <div className="stats-container page-body-container">
                  <div className="stats-columns">
                    <div className="stats-column first">
                      <InfoColumns
                        title={`Closings - ${isYtdClosing ? "YTD" : ytd - 1}`}
                        titleRedirect={`/list?source=STRIVE&status=Closed&close_of_escrow_min=01%2F01%2F${
                          isYtdClosing ? ytd : ytd - 1
                        }&close_of_escrow_max=12%2F31%2F${
                          isYtdClosing ? ytd : ytd - 1
                        }&order=close_of_escrow.desc`}
                        columns={[
                          { key: "Transactions", value: stats.closedYtdCount },
                          { key: "Total Value", value: stats.closedYtdPrice },
                          {
                            key: "Ave Cap Rate",
                            value: stats.closedYtdAvgCapRate,
                          },
                          {
                            key: "List:Close Price",
                            value: stats.listClosedPrice,
                          },
                          {
                            key: "List:Close Time",
                            value: stats.listClosedTime,
                          },
                        ]}
                      />
                      <div className="line" />
                      <InfoColumns
                        title="Current Inventory"
                        titleRedirect="/list?source=STRIVE&status=Active&order=listed_date.desc"
                        columns={[
                          { key: "Properties", value: stats.activeCount },
                          { key: "Total Value", value: stats.activePrice },
                          {
                            key: "Ave Cap Rate",
                            value: stats.activeAvgCapRate,
                          },
                          { key: "Total Sq Ft", value: stats.activeSqft },
                          {
                            key: "Ave Time On Market",
                            value: stats.activeAvgTimeOnMarket,
                          },
                        ]}
                      />
                      <div className="line variable-chart-margin" />
                      <InfoColumns
                        title="Total Under Contract/In Negotiation"
                        titleRedirect="/list?source=STRIVE&status=In+Negotiation%2CUnder+Contract"
                        columns={[
                          { key: "Properties", value: stats.negUcCount },
                          { key: "Total Value", value: stats.negUcPrice },
                          { key: "Total Sq Ft", value: stats.negUcSqft },
                          { key: "Ave Cap Rate", value: stats.negUcAvgCapRate },
                        ]}
                      />

                      <div className="line pie-chart-margin" />
                      <div className="banner-container marginTop50 marginLeft">
                        <div className="stats-title margin-bottom text-center">
                          #1 INVESTMENT TEAM IN THE SOUTHWEST
                        </div>
                        {totalClosedCount}+ TRANSACTIONS | OVER $
                        {totalClosedSum} BILLION SOLD
                      </div>
                      <div className='high-chart page-break'>

                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.barChartData}
                            />

                            </div>
                    </div>

                    <div className="stats-column last">
                      <div className="stats-charts">
                        <VariableChart
                          title="Listed Properties"
                          titleRedirect="/list?source=STRIVE&status=Active&order=listed_date.desc"
                          total={stats.activeCount}
                          data={listedChartData}
                          callBackFunc={(event) => {
                            let eventType = "type";
                            let eventName = event.point.name;
                            if (eventName == "MF") {
                              eventType = "category";
                              eventName = "apartments";
                            }
                            browserHistory.push(
                              `/list?source=STRIVE&status=Active&${eventType}=${eventName}&order=listed_date.desc`
                            );
                          }}
                        />
                        <VariableChart
                          title="Sold Properties"
                          titleRedirect="/list?source=STRIVE&status=Closed&order=close_of_escrow.desc"
                          total={stats.closedCount}
                          data={soldChartData}
                          callBackFunc={(event) => {
                            let eventType = "type";
                            let eventName = event.point.name;
                            if (eventName == "MF") {
                              eventType = "category";
                              eventName = "apartments";
                            }
                            browserHistory.push(
                              `/list?source=STRIVE&status=Closed&${eventType}=${eventName}&order=close_of_escrow.desc`
                            );
                          }}
                        />
                      </div>

                      <div className="line" />
                      <InfoColumns
                        title={`Closed Since ${ytd - 2}`}
                        titleRedirect={`/list?close_of_escrow_min=01%2F01%2F${
                          ytd - 2
                        }&source=STRIVE&status=Closed&order=close_of_escrow.desc`}
                        columns={[
                          {
                            key: "Transactions",
                            value: stats.closedSinceCount,
                          },
                          { key: "Total Value", value: stats.closedSincePrice },
                          { key: "Total Sq Ft", value: stats.closedSinceSqft },
                          {
                            key: "Ave Cap Rate",
                            value: stats.closedSinceAvgCapRate,
                          },
                        ]}
                      />
                      <div className="line" />
                      <InfoColumns
                        title="STRIVE Closings"
                        titleRedirect="/list?source=STRIVE&status=Closed&order=close_of_escrow.desc"
                        columns={[
                          { key: "Transactions", value: stats.closedIsCount },
                          { key: "Total Value", value: stats.closedIsPrice },
                          { key: "Total Sq Ft", value: stats.closedIsSqft },
                          {
                            key: "Ave Cap Rate",
                            value: stats.closedIsAvgCapRate,
                          },
                        ]}
                      />
                      <div className="line page-break" />
                      <div className="stats-title green marginTop50 text-center">
                        <Link
                          to={`/buyer-state-breakdown?base_min=1%2F1%2F${
                            isYtdClosing ? ytd : ytd - 1
                          }&comparison_min=01%2F01%2F${
                            ytd - 2
                          }&source=STRIVE&status=Closed`}
                        >
                          Buyer State Breakdown
                        </Link>
                      </div>
                      <div className="stats-charts marginTop50 flex-column">
                        <PieChart
                          title={
                            isYtdClosing
                              ? `YTD - ${ytd}`
                              : `Closed - ${ytd - 1}`
                          }
                          total={buyerStateYtdTotal}
                          data={buyerStateYtdChartData}
                        />
                        <PieChart
                          title={`Closed since ${ytd - 2}`}
                          total={buyerStateTotal}
                          data={buyerStateChartData}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`print-footer print-footer-1`}>
                    <div className="logo">
                      <img src={arc.path.media + striveLogo} alt="" />
                    </div>
                    {"(469) 844-8880 | strivere.com"}
                  </div>
                  <div className="line page-break" />

                  <div className="stats-tables-container">
                    <StatsColumn
                      keyword="Listed"
                      status="Active"
                      order="LISTED_DATE"
                      price="LIST_PRICE"
                      source="STRIVE"
                    />
                    <div className={`print-footer print-footer-1`}>
                      <div className="logo">
                        <img src={arc.path.media + striveLogo} alt="" />
                      </div>
                      {"(469) 844-8880 | strivere.com"}
                    </div>
                    <StatsColumn
                      keyword="Sold"
                      status="Closed"
                      order="CLOSE_OF_ESCROW"
                      price="SOLD_PRICE"
                      source="STRIVE"
                    />
                  </div>
                </div>
                <div className={`print-footer print-footer-1`}>
                  <div className="logo">
                    <img src={arc.path.media + striveLogo} alt="" />
                  </div>
                  {"(469) 844-8880 | strivere.com"}
                </div>
                <div className="line page-break" />
              </div>

              <div className="stats-print-container">
                <div className="page-height">
                  <div className="stats-print-container_header">
                    <h3 className="stats-print-container_h3">Stats</h3>
                    <h4 className="stats-print-container_h4">{date}</h4>
                  </div>
                  <div className="marginLeft" style={{ height: "710px" }}>
                    <InfoColumns
                      title={`Closings - ${isYtdClosing ? "YTD" : ytd - 1}`}
                      titleRedirect={`/list?source=STRIVE&status=Closed&close_of_escrow_min=01%2F01%2F${
                        isYtdClosing ? ytd : ytd - 1
                      }&close_of_escrow_max=12%2F31%2F${
                        isYtdClosing ? ytd : ytd - 1
                      }`}
                      columns={[
                        { key: "Transactions", value: stats.closedYtdCount },
                        { key: "Total Value", value: stats.closedYtdPrice },
                        {
                          key: "Ave Cap Rate",
                          value: stats.closedYtdAvgCapRate,
                        },
                        {
                          key: "List:Close Price",
                          value: stats.listClosedPrice,
                        },
                        { key: "List:Close Time", value: stats.listClosedTime },
                      ]}
                    />
                    <InfoColumns
                      title="Current Inventory"
                      titleRedirect="/list?source=STRIVE&status=Active"
                      columns={[
                        { key: "Properties", value: stats.activeCount },
                        { key: "Total Value", value: stats.activePrice },
                        { key: "Ave Cap Rate", value: stats.activeAvgCapRate },
                        { key: "Total Sq Ft", value: stats.activeSqft },
                        {
                          key: "Ave Time On Market",
                          value: stats.activeAvgTimeOnMarket,
                        },
                      ]}
                    />
                    <InfoColumns
                      title="Total Under Contract/In Negotiation"
                      titleRedirect="/list?source=STRIVE&status=In+Negotiation%2CUnder+Contract"
                      columns={[
                        { key: "Properties", value: stats.negUcCount },
                        { key: "Total Value", value: stats.negUcPrice },
                        { key: "Total Sq Ft", value: stats.negUcSqft },
                        { key: "Ave Cap Rate", value: stats.negUcAvgCapRate },
                      ]}
                    />
                    <InfoColumns
                      title={`Closed Since ${ytd - 2}`}
                      titleRedirect={`/list?close_of_escrow_min=01%2F01%2F${
                        ytd - 2
                      }&source=STRIVE&status=Closed`}
                      columns={[
                        { key: "Transactions", value: stats.closedSinceCount },
                        { key: "Total Value", value: stats.closedSincePrice },
                        { key: "Total Sq Ft", value: stats.closedSinceSqft },
                        {
                          key: "Ave Cap Rate",
                          value: stats.closedSinceAvgCapRate,
                        },
                      ]}
                    />
                    <InfoColumns
                      title="STRIVE Closings"
                      titleRedirect="/list?source=STRIVE&status=Closed"
                      columns={[
                        { key: "Transactions", value: stats.closedIsCount },
                        { key: "Total Value", value: stats.closedIsPrice },
                        { key: "Total Sq Ft", value: stats.closedIsSqft },
                        {
                          key: "Ave Cap Rate",
                          value: stats.closedIsAvgCapRate,
                        },
                      ]}
                    />
                  </div>
                  <div className={`print-footer print-footer-3`}>
                    <div className="logo">
                      <img src={arc.path.media + striveLogo} alt="" />
                    </div>
                    (469) 844-8880 | strivere.com
                  </div>
                </div>
                <div className="page-break" />
                <div className="page-height">
                  <div className="banner-container marginTop50">
                    <div className="stats-title margin-bottom text-center">
                      #1 INVESTMENT TEAM IN THE SOUTHWEST
                    </div>
                    <span style={{ marginLeft: "170px" }}>
                      {totalClosedCount}+ TRANSACTIONS | OVER ${totalClosedSum}{" "}
                      BILLION SOLD
                    </span>
                  </div>
                  <div
                    className="high-chart"
                    style={{ height: "758px", marginTop: "-150px" }}
                  >
                    <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.barChartData}
                            />
                  </div>
                  <div className={`print-footer print-footer-3`}>
                    <div className="logo">
                      <img src={arc.path.media + striveLogo} alt="" />
                    </div>
                    (469) 844-8880 | strivere.com
                  </div>
                </div>
                <div className="page-break" />
                <div className="page-height">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      height: "816px",
                    }}
                  >
                    <div
                      className="marginTop50"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VariableChart
                        title="Listed Properties"
                        titleRedirect="/list?source=STRIVE&status=Active"
                        total={stats.activeCount}
                        data={listedChartData}
                        callBackFunc={(event) => {
                          let eventType = "type";
                          let eventName = event.point.name;
                          if (eventName == "MF") {
                            eventType = "category";
                            eventName = "apartments";
                          }
                          browserHistory.push(
                            `/list?source=STRIVE&status=Active&${eventType}=${eventName}`
                          );
                        }}
                      />
                      <VariableChart
                        title="Sold Properties"
                        titleRedirect="/list?source=STRIVE&status=Closed"
                        total={stats.closedCount}
                        data={soldChartData}
                        callBackFunc={(event) => {
                          let eventType = "type";
                          let eventName = event.point.name;
                          if (eventName == "MF") {
                            eventType = "category";
                            eventName = "apartments";
                          }
                          browserHistory.push(
                            `/list?source=STRIVE&status=Closed&${eventType}=${eventName}`
                          );
                        }}
                      />
                    </div>
                    <div
                      className="stats-title green text-center"
                      style={{ marginLeft: "-70px" }}
                    >
                      <Link
                        to={`/buyer-state-breakdown?base_min=1%2F1%2F${
                          isYtdClosing ? ytd : ytd - 1
                        }&comparison_min=01%2F01%2F${
                          ytd - 2
                        }&source=STRIVE&status=Closed`}
                      >
                        Buyer State Breakdown
                      </Link>
                    </div>
                    <div
                      className="stats-charts"
                      style={{
                        height: "678px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "-60px",
                      }}
                    >
                      <PieChart
                        title={
                          isYtdClosing ? `YTD - ${ytd}` : `Closed - ${ytd - 1}`
                        }
                        total={buyerStateYtdTotal}
                        data={buyerStateYtdChartData}
                      />
                      <PieChart
                        title={`Closed since ${ytd - 2}`}
                        total={buyerStateTotal}
                        data={buyerStateChartData}
                      />
                    </div>
                  </div>
                  <div className={`print-footer print-footer-3`}>
                    <div className="logo">
                      <img src={arc.path.media + striveLogo} alt="" />
                    </div>
                    (469) 844-8880 | strivere.com
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        }}
      </ApolloConsumer>
    );
  }
}
